// src/components/comment/CommentItem.tsx
import React from 'react';
import { Avatar } from 'antd';
import { TComment } from '../../models/project/project';

/** Formate “Aujourd’hui à …” ou “DD/MM/YYYY à …” */
const formatTimestamp = (ts?: string) => {
  if (!ts) return '';
  const d = new Date(ts);
  const today = new Date();
  const sameDay =
    d.getFullYear() === today.getFullYear() &&
    d.getMonth() === today.getMonth() &&
    d.getDate() === today.getDate();

  const hm = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  const date = d.toLocaleString('fr-FR');
  return sameDay ? `Aujourd'hui à ${hm}` : `${date} à ${hm}`;
};

interface Props {
  comment: TComment;
}

const CommentItem: React.FC<Props> = ({ comment }) => {
  const userName = comment.author_name || 'Utilisateur';
  const dateStr = formatTimestamp(comment.created_at);

  return (
    <div style={{ display: 'flex', marginBottom: 16 }}>
      <Avatar style={{ backgroundColor: '#87d068', marginRight: 12 }}>
        {userName.charAt(0).toUpperCase()}
      </Avatar>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 600, marginBottom: 4 }}>
          {userName}{' '}
          <small style={{ color: '#888', fontWeight: 'normal' }}>
            {dateStr}
          </small>
        </div>
        <div style={{ lineHeight: 1.5 }}>
          {comment.content}
        </div>
      </div>
    </div>
  );
};

export default CommentItem;
